import { useNavigate } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faThumbsUp, faComment } from '@fortawesome/free-solid-svg-icons';
import PostImages from './PostImages';
import placeholder_portrait_40x40 from '@/assets/imgs/placeholders/portrait_40x40.png';
import SafeImg from '@/components/shared/SafeImg';
import IdolName from '@/components/ui/IdolName';
import RelativeTime from '@/components/shared/RelativeTime';

const PostPreviewCard = ({ data, contentType = 'post' }) => {
  const navigate = useNavigate();

  const getPostData = () => {
    if (contentType === 'world') {
      const worldInfo = data.world_info;
      return {
        authorInfo: data.side_info,
        contentInfo: worldInfo,
        createdAt: worldInfo.world_created_at,
        likeCount: worldInfo.world_like_count,
        commentCount: worldInfo.world_comment_count,
        title: worldInfo.world_title,
        content: worldInfo.world_content,
      };
    } else {
      return {
        authorInfo: data.idol_info,
        contentInfo: data.post_info,
        createdAt: data.post_info.post_created_at,
        likeCount: data.post_info.post_like_count,
        commentCount: data.post_info.post_comment_count,
        title: null,
        content: data.post_info.post_content,
        isLocked: data.post_info.post_is_locked,
        lockType: data.post_info.post_lock_type,
        unlockPrice: data.post_info.post_unlock_price,
      };
    }
  };

  const postData = getPostData();

  // 圖片（世界觀只取第一張，與 PostCard 一致）
  const oldImages = contentType === 'world'
    ? data.world_info.world_media.slice(0, 1)
    : data.post_info.post_media;

  const handleClick = () => {
    const url = contentType === 'world'
      ? `/world-view/${postData.contentInfo.world_uuid}`
      : `/post/${postData.contentInfo.post_uuid}`;
    navigate(url);
  };

  return (
    <div className="activity-item border mb-3 rounded bg-white shadowA card-hover-p" onClick={handleClick}>
      <div className="p-3">

        {/* 作者列 */}
        <div className="item-top-bar">
          <div className="left-bar position-relative mb-2 d-flex">
            <div className="img-sm me-2 flex-shrink-0">
              <SafeImg
                className="img-fluid rounded-pill"
                src={postData.authorInfo.idol_avatar_url || placeholder_portrait_40x40}
                alt={postData.authorInfo.idol_nick_name}
              />
            </div>
            <div className="activity-idol-info min-w-0">
              <div className="all-name min-w-0">
                <IdolName
                  name={postData.authorInfo.idol_nick_name}
                  isOfficial={postData.authorInfo.idol_is_official}
                  className="name"
                />
              </div>
              <div className="time">
                <RelativeTime value={postData.createdAt} />
              </div>
            </div>
          </div>
        </div>

        {/* 世界觀標題 */}
        {contentType === 'world' && postData.title && (
          <h4 className="mb-2">{postData.title}</h4>
        )}

        {/* 世界觀圖片（內容前） */}
        {contentType === 'world' && oldImages.length > 0 && (
          <PostImages
            contentType="world"
            oldImages={oldImages}
            newImages={[]}
            editing={false}
            disabled={true}
          />
        )}

        {/* 內容（截斷顯示，無 see more） */}
        {postData.content && (
          <div
            className="post-edit"
            style={{ display: '-webkit-box', WebkitLineClamp: 4, WebkitBoxOrient: 'vertical', overflow: 'hidden' }}
          >
            {postData.content}
          </div>
        )}

        {/* 貼文圖片（內容後） */}
        {contentType === 'post' && oldImages.length > 0 && (
          <PostImages
            contentType="post"
            oldImages={oldImages}
            newImages={[]}
            editing={false}
            disabled={true}
            isLocked={postData.isLocked}
            lockType={postData.lockType}
            unlockPrice={postData.unlockPrice}
          />
        )}

        {/* 統計 */}
        <div className="d-flex justify-content-end mt-3 gap-2">
          <div className="text-gray me-2">
            <span className="me-1">{postData.likeCount}</span>
            <FontAwesomeIcon icon={faThumbsUp} />
          </div>
          <div className="text-gray">
            <span className="me-1">{postData.commentCount}</span>
            <FontAwesomeIcon icon={faComment} />
          </div>
        </div>

      </div>
    </div>
  );
};

export default PostPreviewCard;
